export const GAME_DURATIONS = {
    SEVEN: "7",
    FOURTEEN: "14",
    THIRTY: "30",
    SIXTY: "60",
    NINETY: "90",
};